module.exports = __webpack_public_path__ + "static/media/41.0eedd0fb.jpg";